<!--
    描述： 跟踪审计 申报进度款树结构列表页面
    时间： 2020/5/27
    created by zjj
-->
<template>
    <div class="track-comparison-table"
         ref="tableContent">
        <!-- 树形表格-->
        <el-table :data="tableData"
                  row-key="id"
                  border
                  v-loading="loading"
                  ref="xTable"
                  :height="tableH"
                  :row-class-name="rowClassName"
                  :expand-row-keys="expandKeys"
                  stripe
                  highlight-current-row
                  :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column prop="cost_name"
                             label="名称"
                             show-overflow-tooltip
                             min-width="160">
                <template slot="header"
                          slot-scope="scope">
                    名称
                    <el-select v-model="curLevel"
                               class="ml10 select-width"
                               placeholder="请选择"
                               size="small"
                               @change="onChangeLevel">
                        <el-option :value="0"
                                   label="展开到一级"></el-option>
                        <el-option :value="1"
                                   label="展开到二级"></el-option>
                        <el-option :value="2"
                                   label="展开到三级"></el-option>
                        <el-option :value="3"
                                   label="展开到四级"></el-option>
                    </el-select>
                </template>
                <template slot-scope="scope">
                    {{ scope.row.cost_name }}
                    <el-tooltip placement="right"
                                effect="light"
                                v-if="scope.row.tags !== '' && [0, 1].includes(scope.row.levelType)">
                        <div slot="content"
                                class="tag-label-tooltip">
                            <el-tag class="mr10 mb10"
                                    size="mini"
                                    v-for="(item, index) in toArray(scope.row.tags)"
                                    :key="index">{{ item }}</el-tag>
                        </div>
                        <svg-icon icon-class="biaoqian"
                                    class="ml5"></svg-icon>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column prop="heTongPrice"
                             width="125"
                             header-align="center"
                             align="right"
                             v-if="filterColumns.indexOf('heTongPrice')>=0"
                             show-overflow-tooltip
                             :label="`合同价款 (${unitName})`">
                <template slot-scope="scope">
                    <div>{{ unitName === '元' ? scope.row.heTongPrice : (scope.row.heTongPrice/10000).toFixed(2) }}
                    </div>
                </template>
            </el-table-column>
            <template v-if="navIndex === 1001">
                <el-table-column prop="shenBaoSum"
                                 width="165"
                                 header-align="center"
                                 align="right"
                                 v-if="filterColumns.indexOf('shenBaoSum')>=0"
                                 show-overflow-tooltip
                                 :label=" `累计申报产值 (${unitName})`">
                    <template slot-scope="scope">
                        <div>{{ unitName === '元' ? scope.row.shenBaoSum : (scope.row.shenBaoSum/10000).toFixed(2) }}
                        </div>
                    </template>
                </el-table-column>
            </template>
            <template v-else>
                <el-table-column prop="piZhunSum"
                                 width="165"
                                 header-align="center"
                                 align="right"
                                 v-if="filterColumns.indexOf('piZhunSum')>=0"
                                 show-overflow-tooltip
                                 :label="`累计审核产值 (${unitName})`">
                    <template slot-scope="scope">
                        <div>{{ unitName === '元' ? scope.row.piZhunSum : (scope.row.piZhunSum/10000).toFixed(2) }}
                        </div>
                    </template>
                </el-table-column>
            </template>
            <template>
                <el-table-column prop="progressPayment"
                                 width="165"
                                 header-align="center"
                                 align="right"
                                 show-overflow-tooltip
                                 :label="navIndex === 1001 ? `累计申报进度款 (${unitName})` : `累计审核进度款 (${unitName})`">
                    <template slot-scope="scope">
                        <template v-if="navIndex === 1001">
                            <div>{{ unitName === '元' ? scope.row.declareProgressPayment : (scope.row.declareProgressPayment/10000).toFixed(2) }}</div>
                        </template>
                        <template v-else>
                            <div>{{ unitName === '元' ? scope.row.examineProgressPayment : (scope.row.examineProgressPayment/10000).toFixed(2) }}</div>
                        </template>
                    </template>
                </el-table-column>
            </template>
            <el-table-column prop="piZhunBalance"
                             width="110"
                             header-align="center"
                             align="right"
                             v-if="filterColumns.indexOf('piZhunBalance')>=0 && navIndex === 1001"
                             show-overflow-tooltip
                             :label="`余额 (${unitName})`">
                <template slot-scope="scope">
                    <div>{{ unitName === '元' ? scope.row.shenBaoBalance : (scope.row.shenBaoBalance/10000).toFixed(2) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="piZhunBalance"
                             width="110"
                             header-align="center"
                             align="right"
                             v-if="filterColumns.indexOf('piZhunBalance')>=0 && navIndex === 1002"
                             show-overflow-tooltip
                             :label="`余额 (${unitName})`">
                <template slot-scope="scope">
                    <div>{{ unitName === '元' ? scope.row.piZhunBalance : (scope.row.piZhunBalance/10000).toFixed(2) }}
                    </div>
                </template>
            </el-table-column>
            <template v-if="navIndex === 1001">
                <el-table-column prop="shenBaoBiLi"
                                 width="120"
                                 header-align="center"
                                 align="right"
                                 v-if="filterColumns.indexOf('shenBaoBiLi')>=0"
                                 show-overflow-tooltip
                                 :label="'累计申报比例'">
                    <template slot-scope="scope">
                        <div :class="{'color-red': parseFloat(scope.row.shenBaoBiLi) > 100}">{{ scope.row.shenBaoBiLi }}
                        </div>
                    </template>
                </el-table-column>
            </template>
            <template v-else>
                <el-table-column prop="piZhunBiLi"
                                 width="120"
                                 header-align="center"
                                 align="right"
                                 v-if="filterColumns.indexOf('piZhunBiLi')>=0"
                                 show-overflow-tooltip
                                 :label="'累计审核比例'">
                    <template slot-scope="scope">
                        <div :class="{'color-red': parseFloat(scope.row.piZhunBiLi) > 100}">{{ scope.row.piZhunBiLi }}
                        </div>
                    </template>
                </el-table-column>
            </template>
            <el-table-column prop="shengYuShenBao"
                             width="110"
                             header-align="center"
                             align="right"
                             class-name="border-column"
                             v-if="filterColumns.indexOf('shengYuShenBao')>=0"
                             show-overflow-tooltip
                             label="剩余比例">
                <template slot-scope="scope">
                    <div :class="{'color-red': (navIndex === 0 && parseFloat(scope.row.shengYuShenBao) <= 0) || (navIndex === 1 && parseFloat(scope.row.shengYuPiZhun) <= 0)}">
                        {{ navIndex === 1001 ? scope.row.shengYuShenBao : scope.row.shengYuPiZhun }}
                    </div>
                </template>
            </el-table-column>
            <template v-if="navIndex === 1001">
                <el-table-column v-for="(item, index) in periodsList"
                                 :key="'期数' + index"
                                 :prop="`shenBaoList[${index}].cost_value`"
                                 class-name="period-column"
                                 v-if="filterColumns.indexOf(`shenBaoList[${index}].cost_value`)>=0"
                                 width="115"
                                 header-align="center"
                                 align="right"
                                 show-overflow-tooltip
                                 :label="`第${item.number_periods}期 (${unitName})`">
                    <template slot-scope="scope">
                        <el-tooltip placement="right"
                                    v-if="scope.row.levelType === 0">
                            <div slot="content">
                                <p>填报金额：{{ unitName === '元' ? item.float : (item.float/10000).toFixed(2) }}{{ unitName
                                    }}
                                </p>
                            </div>
                            <div>{{ showMoney(scope.row, item) }}</div>
                        </el-tooltip>
                        <div v-else>{{ showMoney(scope.row, item) }}</div>
                    </template>
                </el-table-column>
            </template>
            <template v-else>
                <el-table-column v-for="(item, index) in periodsList"
                                 :key="'期数' + index"
                                 :prop="`piZhunList[${index}].cost_value`"
                                 class-name="period-column"
                                 v-if="filterColumns.indexOf(`piZhunList[${index}].cost_value`)>=0"
                                 width="115"
                                 header-align="center"
                                 align="right"
                                 show-overflow-tooltip
                                 :label="`第${item.number_periods}期 (${unitName})`">
                    <template slot-scope="scope">
                        <el-tooltip placement="right"
                                    v-if="scope.row.levelType === 0">
                            <div slot="content">
                                <p>填报金额：{{ unitName === '元' ? item.float : (item.float/10000).toFixed(2) }}{{ unitName
                                    }}
                                </p>
                            </div>
                            <div>{{ showMoney(scope.row, item) }}</div>
                        </el-tooltip>
                        <div v-else>{{ showMoney(scope.row, item) }}</div>
                    </template>
                </el-table-column>
            </template>
        </el-table>

    </div>
</template>
<script>
    import {mapState} from 'vuex'

    export default {
        name: 'track-audit-payment-table',
        props: {
            treeDataList: {
                type: Array,
                default: []
            },
            // tab切换模式 （0 是申报， 1 是批准）
            navIndex: {
                type: Number,
                default: 0
            },
            //单位类型名称
            unitName: {
                type: String,
                default: ''
            },
            //期数
            periodsList: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                curLevel: 2,
                tableH: 100,
                loading: false,
                expandKeys: [],
                // 列过滤数组
                filterColumns: [
                    'heTongPrice',
                    'shenBaoSum',
                    'piZhunSum',
                    'shenBaoBiLi',
                    'piZhunBiLi',
                    'shengYuPiZhun'
                ],
                tableData: []
            }
        },
        methods: {
            getRowKey(row) {
                return row.id
            },

            // 行样式
            rowClassName({row, rowIndex}) {
                if (row.levelType === 0) {
                    return 'project-row'
                } else if (row.levelType === 1) {
                    return 'single-row'
                } else if (row.levelType === 2) {
                    return 'unit-row'
                }
                return ''
            },

            // 点击切换展开层级
            onChangeLevel(val) {
                this.loading = true
                // 先清空
                this.tableData = []
                this.expandKeys = []

                // 设置 level
                let _data = JSON.parse(JSON.stringify(this.treeDataList))
                this.expandLevel(_data, val, this.expandKeys)

                // 展示表格
                setTimeout(() => {
                    this.loading = false
                    this.tableData = this.treeDataList
                    this.$refs.xTable.doLayout()
                }, 500)
            },

            // 默认key 值展开
            expandLevel(arr, level, backArr) {
                if (arr.length > 0) {
                    arr.forEach(x => {
                        if (x.children && x.levelType < level) {
                            backArr.push(x.id)
                            this.expandLevel(x.children, level, backArr)
                        }
                    })
                }
            },

            // 期数金额处理
            showMoney(row, obj) {
                if (this.navIndex === 1001) {
                    if (row.shenBaoList && row.shenBaoList.length > 0) {
                        let item = row.shenBaoList.find(
                            x => x.number_periods === obj.number_periods
                        )

                        if (item) {
                            return this.unitName === '元'
                                ? item.cost_value
                                : (parseFloat(item.cost_value) / 10000).toFixed(2)
                        }

                        return 0
                    }
                } else {
                    if (row.piZhunList && row.piZhunList.length > 0) {
                        let item = row.piZhunList.find(
                            x => x.number_periods === obj.number_periods
                        )

                        if (item) {
                            return this.unitName === '元'
                                ? item.cost_value
                                : (parseFloat(item.cost_value) / 10000).toFixed(2)
                        }

                        return 0
                    }
                }
                return 0
            },

            // 重新调整 表格高度
            resizeTable() {
                if (this.$refs.xTable) {
                    this.$refs.xTable.doLayout()
                    this.tableH = this.$refs.tableContent.offsetHeight
                }
            },

            // 展示标签
            toArray(str) {
                let arr = str.split(',').filter((x) => x !== '')
                return arr
            },
        },
        created() {
            this.$nextTick(() => {
                this.tableH = this.$refs.tableContent.offsetHeight
            })
        },
        computed: {
            ...mapState('app', {
                clientSize: state => state.clientSize
            })
        },
        watch: {
            clientSize() {
                this.$nextTick(() => {
                    this.tableH = this.$refs.tableContent.offsetHeight
                    this.$refs.xTable.doLayout()
                })
            },
            //监听列表数据
            treeDataList(val) {
                if (val) {
                    this.onChangeLevel(2)
                    // this.tableData = val
                    // this.$refs.xTable.doLayout()
                }
            },
            //监听期数
            periodsList(val) {
                if (this.navIndex === 1001) {
                    if (val.length > 0) {
                        val.map((item, index) => {
                            this.filterColumns.push(
                                `shenBaoList[${index}].cost_value`
                            )
                        })
                    }
                } else {
                    if (val.length > 0) {
                        val.map((item, index) => {
                            this.filterColumns.push(
                                `piZhunList[${index}].cost_value`
                            )
                        })
                    }
                }
            }
        }
    };
</script>
<style lang="less" scoped>
    .track-comparison-table {
        .select-width {
            float: right;
            width: 130px;
        }

        /deep/ .el-table {
            @color: #039be5;

            .border-column {
                border-right-color: @color !important;
            }

            .el-table__header .period-column {
                background-color: @color !important;
            }

            .color-red {
                color: red;
            }
        }
    }
</style>